import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { queryClient } from 'providers/AllProviders';
import { getAgencyAddons, updateAgencyAddon } from './api';
import { AgencyAddon, UpdateAgencyAddonPayload } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export const AGENCY_ADDONS_QUERY_KEY = ['agency_addons'];

type AgencyAddonsResponse = {
  data: AgencyAddon[];
  meta?: MetaApiResponse;
};

export function useGetAgencyAddons(options?: UseQueryOptions<AgencyAddonsResponse, Error>) {
  return useQuery<AgencyAddonsResponse>({
    queryKey: AGENCY_ADDONS_QUERY_KEY,
    queryFn: getAgencyAddons,
    ...options
  });
}

export function useUpdateAgencyAddon() {
  return useMutation({
    mutationFn: ({ id, payload }: { id: string | number; payload: UpdateAgencyAddonPayload }) =>
      updateAgencyAddon(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: AGENCY_ADDONS_QUERY_KEY,
        refetchType: 'active'
      });
    }
  });
}
